import React from 'react';
import { Routes, Route, Navigate, Link } from 'react-router-dom';

// Import all route components
import Home from './Home';
import Test from './Test';
import ConversationalFramework, { getNavLinks as getCFNav } from './ConversationalFramework';
import Timeline from './Timeline';

// Define route configuration
const routeConfig = [
  { path: '/', component: Home, exact: true },
  { path: '/home', component: Home },
  { path: '/test', component: Test },
  { path: '/conversational-framework', component: ConversationalFramework, getNavLinks: getCFNav },
  { path: '/conversational-framework/:displayId', component: ConversationalFramework },
  { path: '/timeline', component: Timeline },
];

// Navigation component to display all routes
const RouteNavigation: React.FC = () => {
  return (
    <nav style={{ textAlign: 'center' }}>
      <ul style={{ display: 'inline-block', textAlign: 'left' }}>
        {routeConfig
          .filter(({ path }) => path !== '/' && !path.includes(':'))
          .map(({ path, getNavLinks }) => (
            <li key={path}>
              <Link to={path}>{path}</Link>
              {typeof getNavLinks === 'function' && (
                <ul>
                  {getNavLinks(path)?.map((link: { to: string; label: string }) => (
                    <li key={link.to}>
                      <Link to={link.to}>{link.to}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {routeConfig.map(({ path, component: Component, exact }) => (
        <Route 
          key={path} 
          path={path} 
          element={<Component />} 
        />
      ))}
      {/* Redirect any unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
export { RouteNavigation };
